import type { ToolDenialReason } from "@playbookai/api-clients";

/** Why workspace-enabled access is not in effect, in a member's words (PB-5134).
 * Shared by the manual tool list and Player AI's connected apps so the two
 * surfaces never explain the same reason differently. */
const DENIAL_LABELS: Readonly<Record<ToolDenialReason, string>> = {
  integration_disabled: "integration disabled",
  no_grant: "workspace access removed",
  connection_unusable: "connection needs attention",
  connection_not_mcp: "MCP is not enabled on this connection",
  tool_not_enabled: "admin disabled the tool",
  tool_unclassified: "admin review required",
  tool_schema_unusable: "tool schema is temporarily unsupported",
  user_read_only: "Player AI access is read only",
  no_preference: "not selected in custom access",
  schema_changed: "the tool changed and must be selected again",
  user_disabled: "not selected in custom access",
};

export function denialLabel(reason: ToolDenialReason): string {
  return DENIAL_LABELS[reason];
}

/** "Not currently available: reason, reason." for a governed tool. */
export function notAvailableCopy(reasons: readonly ToolDenialReason[]): string {
  return `Not currently available: ${reasons.map(denialLabel).join(", ")}.`;
}
